import * as loader from "../components/file-loader/utils/utils";

const createPreview = (tmp, file, input) => {
  let preview = tmp.cloneNode(true);
  preview.title = file.name;
  preview.querySelector(".filename").textContent = file.name;
  preview.appendChild(input);
  return preview;
}

const initLoader = (form, config = {}) => {
  let addFilesButton = form.querySelector('[data-add-files]');

  let previewContainer = form.querySelector('[data-previews]');
  let previewTmp = form.querySelector('[data-preview-tmp]');

  if (!addFilesButton) return;
  let name = addFilesButton.dataset.name;

  form.addEventListener("reset", () => {
    if (previewContainer) previewContainer.innerHTML = "";
  });

  addFilesButton.addEventListener("click", () => {
    loader.selectFiles({
      multiple: addFilesButton.hasAttribute('data-multiple'),
      accept: addFilesButton.dataset.accept
    }).then(({files, input}) => {
      input.name = name;
      addFilesButton.dispatchEvent(new Event("change"));

      let maxCount = Math.min(parseInt(addFilesButton.dataset.maxCount) || 1, files.length);
      if (previewContainer) {
        previewContainer.innerHTML = "";
      }
      
      for (let i = 0; i < maxCount; i++) {
        let file = files[i];
        if (!file) break;
        if (previewTmp) {
          let preview = createPreview(previewTmp, file, input);
          previewContainer.appendChild(preview);

          preview.addEventListener("click", (e) => {
            if (e.target.closest("[data-remove-file]")) {
              addFilesButton.dispatchEvent(new CustomEvent("interlock.reset"));
            }
          }, true);
        }
        if (config.onLoad && typeof config.onLoad === "function") {
          config.onLoad(file, input);
        }
      }

    })
  })
}

export { initLoader };